import { User } from '@capacitor-firebase/authentication';
import * as Sentry from '@sentry/react';
import { getEnvironment } from '../utils';

export class LogService {
  private static instance: LogService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): LogService {
    if (!LogService.instance) {
      LogService.instance = new LogService();
    }
    return LogService.instance;
  }

  logError(
    error: unknown,
    props?: Record<string, unknown>,
    tags?: Record<string, string>,
    level: 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug' = 'error'
  ) {
    if (getEnvironment() !== 'local') {
      Sentry.captureException(error, {
        level,
        extra: {
          ...props,
        },
        tags,
      });
    } else {
      console.error('[LogService] Error:', error, props, tags, level);
    }
  }

  logInfo(
    message: string,
    props?: Record<string, unknown>,
    tags?: Record<string, string>,
    level: 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug' = 'info'
  ) {
    if (getEnvironment() !== 'local') {
      Sentry.captureMessage(message, {
        level,
        extra: {
          ...props,
        },
        tags,
      });
    } else {
      console.log('[LogService] Info:', message, props, tags, level);
    }
  }

  setUser(user: User | null) {
    Sentry.setUser(
      user
        ? {
            email: user?.email ?? undefined,
            id: user?.uid ?? undefined,
          }
        : null
    );
  }
}
